/* -----------------Globals--------------- */
import type { FolderContentsItemsCount } from "@memorang/types";

/* -----------------UI--------------- */
import { List } from "react-native-paper";

import Box from "../Box";
/* -----------------Child components--------------- */
import ProductIcon from "../ProductIcon";
import ProductStatusChip from "./ProductStatusChip";
import { getItemsCountDescription } from "./helpers";

/* -----------------Types--------------- */
export type Product = {
	name: string;
	iconUrl?: string;
	contentsItemsCount?: FolderContentsItemsCount;
};

/* -----------------Props--------------- */
type Props = {
	statusText?: string;
	expired?: boolean;
	size?: number;
	product: Product;
	handleOpenProductModal: () => void;
	showRightView?: boolean;
	rightComp?: React.ReactElement;
	showIcon?: boolean;
	enableBoxShadow?: boolean;
	customTitle?: string;
};

/* -----------------Component--------------- */
const ProductListItem = (props: Props) => {
	const {
		statusText,
		expired,
		size,
		rightComp,
		showRightView = true,
		showIcon = true,
		product,
		handleOpenProductModal,
		enableBoxShadow = true,
		customTitle,
	} = props;
	const { name: title, iconUrl, contentsItemsCount } = product;

	const itemsCountDescription = getItemsCountDescription(contentsItemsCount);

	const renderRight = () => (
		<Box alignSelf="center">
			{rightComp || (
				<Box>
					{statusText && (
						<ProductStatusChip label={statusText} expired={expired} />
					)}
				</Box>
			)}
		</Box>
	);

	return (
		<List.Item
			style={{
				paddingVertical: 12,
				paddingHorizontal: 16,
			}}
			title={customTitle || title}
			titleStyle={{ fontWeight: "500", paddingRight: 16 }}
			titleNumberOfLines={2}
			description={itemsCountDescription}
			descriptionStyle={{ fontSize: 12 }}
			onPress={handleOpenProductModal}
			left={() =>
				iconUrl &&
				showIcon && (
					<ProductIcon
						enabledBoxShadow={enableBoxShadow}
						image={iconUrl}
						size={size!}
					/>
				)
			}
			right={() => showRightView && renderRight()}
		/>
	);
};

export default ProductListItem;
